<template>
    <div class="navbar d-flex a-center">
        <div class="nav-container">
            <div class="nav-item nav-item-teacher" :class="{ active: $route.name == 'screen_teacher_new' }"
                @click="navigateTo('screen_teacher_new')">
                <img :src="activeMenu === 'teacherProfileNew' ? require('../assets/header/icon-js-active.png') : require('../assets/header/icon-js.png')"
                    alt="教师当前画像" class="nav-icon">
                <span>教师当前画像</span>
            </div>
            <div class="nav-item nav-item-lesson" :class="{ active: $route.name == 'screen_class' }"
                @click="navigateTo('screen_class')">
                <img :src="activeMenu === 'courseProfile' ? require('../assets/header/icon-kc-active.png') : require('../assets/header/icon-kc.png')"
                    alt="课程当前画像" class="nav-icon">
                <span>课程当前画像</span>
            </div>
            <div class="nav-item nav-item-report" :class="{ active: $route.name == 'screen_report' }"
                @click="navigateTo('screen_report')">
                <img :src="activeMenu === 'evaluationReport' ? require('../assets/header/icon-pk-active.png') : require('../assets/header/icon-pk.png')"
                    alt="评课报告" class="nav-icon">
                <span>评课报告</span>
            </div>
            <div class="nav-item nav-item-chat" :class="{ active: $route.name == 'screen_dialogue' }"
                @click="navigateTo('screen_dialogue')">
                <img :src="activeMenu === 'aiDiscussion' ? require('../assets/header/icon-znt-active.png') : require('../assets/header/icon-znt.png')"
                    alt="智能体议课" class="nav-icon">
                <span>智能体议课</span>
            </div>
            <div class="nav-item nav-item-resource" @click="handleClick2('reflect')">
                <img :src="activeMenu === 'teachingReflection' ? require('../assets/header/icon-fs-active.png') : require('../assets/header/icon-fs.png')"
                    alt="教学反思" class="nav-icon">
                <span>教学反思</span>
            </div>
            <div class="nav-item nav-item-exit" @click="handleLogout">
                <img :src="require('../assets/header/icon-tc.png')" alt="退出" class="nav-icon">
                <span>退出</span>
            </div>
        </div>
        <div class="user-info d-flex a-center">
            <el-dropdown @command="handleClick">
                <span class="el-dropdown-link d-flex a-center">
                    <el-avatar style="margin-right:10px;" size="medium"
                        src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
                    {{ $store.state.user.username }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="resetPassword">修改密码</el-dropdown-item>
                    <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'Header',
    props: {
        params: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            activeMenu: 'teacherProfile'
        }
    },
    mounted() {
        switch (this.$route.name) {
            case 'screen_teacher_new': this.activeMenu = 'teacherProfileNew'; break;
            case 'screen_class': this.activeMenu = 'courseProfile'; break;
            case 'screen_report': this.activeMenu = 'evaluationReport'; break;
            case 'screen_dialogue': this.activeMenu = 'aiDiscussion'; break;
        }
    },
    methods: {
        ...mapMutations(['logout']),
        navigateTo(routeName) {
            switch (routeName) {
                case 'screen_teacher_new': this.activeMenu = 'teacherProfileNew'; break;
                case 'screen_class': this.activeMenu = 'courseProfile'; break;
                case 'screen_report': this.activeMenu = 'evaluationReport'; break;
                case 'screen_dialogue': this.activeMenu = 'aiDiscussion'; break;
                case 'teachingReflection': this.activeMenu = 'teachingReflection'; break;
            }
            const query = { ...this.params, ...this.$route.query };
            this.$router.push({ name: routeName, query });
        },
        handleClick2(status) {
            this.$emit('change', status);
        },
        handleClick(command) {
            if (command === 'resetPassword') this.$emit('reset-password');
            else if (command === 'logout') {
                this.logout()
                this.$router.push('/login')
            }
        },
        handleLogout() {
            this.$router.push('/auto')
        }
    }
}
</script>

<style scoped lang="less">
@primary-color: #1890ff;
@inactive-color: #b7b7b7;

.navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 6.70vh; // 72 / 1080
    z-index: 9;
    color: #333;
    display: flex;
    align-items: center;
}

.nav-container {
    display: flex;
    align-items: center;
    margin-left: 27.34vw; // 525 / 1920
    height: 4.4vh; // 46 / 1080
    width: 58.07vw; // 1115 / 1920
    background: url(../assets/imgs/nav-bg.png) no-repeat center center;
    background-size: 100% 100%;
}

.nav-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    height: 4.26vh; // 46 / 1080
    font-size: 1.04vw; // 20 / 1920

    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.44), rgba(158, 209, 255, 0.44));
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;

    &:hover,
    &.active {
        background: linear-gradient(to bottom, #C6DFFF 2%, #0773FF);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }
}

/* 按设计稿比例换算 */
.nav-item-exit {
    width: 6.51vw !important; // 125 / 1920
}

.nav-item-teacher {
    width: 10.94vw !important; // 210 / 1920
}

.nav-item-lesson {
    width: 10.42vw !important; // 200 / 1920
}

.nav-item-report {
    width: 10.42vw !important; // 200 / 1920
}

.nav-item-chat {
    width: 9.9vw; // 190 / 1920
}

.nav-item-resource {
    width: 9.38vw; // 180 / 1920
}

.nav-icon {
    width: 1.04vw; // 20 / 1920
    height: 1.04vw; // 与宽度保持一致，确保图标为正方形
    margin-right: 0.31vw; // 6 / 1920
    object-fit: contain; // 确保图片内容完整显示
}

.user-info {
    color: #fff;
    margin-left: auto;
    padding-right: 1.04vw; // 20 / 1920
}

.d-flex {
    display: flex;
}

.a-center {
    align-items: center;
}

/deep/ .el-dropdown {
    color: #ffffff;
}
</style>
